module.exports = __webpack_public_path__ + "img/PL08146.8bea59c8.png";